

import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { observer } from "mobx-react";
import { DetailedHTMLProps, HTMLAttributes } from "react";
import { FormInputItem } from "../../../../stores/models/FormInputItem";
import ElementDescription from "./ElementDescription";
import ElementTitle from "./ElementTitle";
import REMKeyboardDatePicker from "../../../../shared/modules/rem-conversion/components/KeyboardDatePicker";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        flex: {
            display: 'flex'
        },
        description: {
            marginTop: theme.spacing(.5)
        }
    }),
);

interface DateSelectionItemProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    item: FormInputItem;
}

const DateSelectionItem = observer((props: DateSelectionItemProps) => {

    const classes = useStyles();

    const onDateChange = (date: MaterialUiPickersDate, value?: string | null | undefined) => {
        const newValue = date ? date.toUTCString() : "";
        props.item.setValue(newValue);
    }

    /********** Render *********/


    return (
        <div  {...props}>
            <ElementTitle item={props.item} />
            <ElementDescription variant="subtitle2" item={props.item} className={classes.description} />
            <div className={classes.flex}>
                <REMKeyboardDatePicker
                    id="date-picker"
                    format="MM/dd/yyyy"
                    value={props.item.value ? props.item.value : null}
                    onChange={(date, value) => onDateChange(date, value)}
                    inputVariant="outlined"
                    required
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    error={props.item.errors.value ? true : false}
                    helperText={props.item.errors.value}
                />
            </div>
        </div>
    )
});

export default DateSelectionItem;